var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMediaLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.976.167c.607 0 1.143.536 1.143 1.179v13.678a1.15 1.15 0 0 1-1.143 1.143H1.226c-.607 0-1.107-.5-1.107-1.143V1.346C.12.703.62.167 1.226.167zM4.941 13.881V6.274H2.583v7.607zM3.762 5.203c.75 0 1.357-.607 1.357-1.357s-.607-1.393-1.357-1.393c-.786 0-1.393.643-1.393 1.393s.607 1.357 1.393 1.357m10.071 8.678V9.703c0-2.036-.464-3.643-2.857-3.643-1.143 0-1.928.643-2.25 1.25h-.035V6.274H6.44v7.607h2.357v-3.75c0-1 .178-1.964 1.428-1.964 1.215 0 1.215 1.143 1.215 2v3.714z"
})));
export default SvgSocialMediaLinkedin;